module.exports = __webpack_public_path__ + "browserconfig.xml";